var render = function render(){var _vm=this,_c=_vm._self._c;return _c('push-card',{attrs:{"lang":_vm.lang,"push-card-sdk":_vm.pushCardSdk},on:{"open":_vm.handleOpen}})
}
var staticRenderFns = []

export { render, staticRenderFns }